<template>
  <v-theme-provider dark>
    <base-section
      id="contact-us"
      class="primary"
      space="40"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="10">
            <base-title
              :space="$vuetify.breakpoint.mdAndUp ? 0 : 4"
              title="¿TIENES ALGUNA PREGUNTA? CONTÁCTENOS!"
            />

            <base-body space="0">
              <span class="white--text">
                Envíanos un email y permítenos resolver tus dudas.
              </span>
            </base-body>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <base-btn
              :block="$vuetify.breakpoint.smAndDown"
              color="white"
              href="mailto:info@paintcleanbox.com?subject=Dudas%20Paint%20Clean%20Box"
              large
              outlined
              target="_blank"
            >
              Contactar
            </base-btn>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionContactUs',
  }
</script>
